import { OrNull } from '~src/typing.utils';

import { UserPermissions } from './session.types';

export type UserSettingsAttrs = Record<string, string | null>;
export type ManagerAttrs = Record<string, User | null>;

export interface User extends UserCore {
  created_at: string;
  custom_attributes?: Record<string, string | number | null>;
  deleted_at: string | null;
  external: boolean;
  framework: boolean;
  imageUrl: string | null;
  manager_attributes: ManagerAttrs;
  name?: string;
  setting_attributes?: UserSettingsAttrs;
  updated_at: string;
  userPermissions?: UserPermissions[];
  username?: string;
  uuid: string;
}

export interface UserCore {
  deactivated: boolean;
  email: string;
  firstname: string;
  lastname: string;
  username?: string;
}

export function getUserFullName(user: { firstname: string; lastname: string }): string {
  return `${user.firstname} ${user.lastname}`;
}

export type UserCorePatch = Partial<OrNull<UserCore>>;

export function extractCoreValues(user: User): UserCore {
  return {
    deactivated: user.deactivated,
    email: user.email,
    firstname: user.firstname,
    lastname: user.lastname,
    username: user.username,
  };
}

export function partialUserCoreToPatch(userFormValues: Partial<UserCore>): UserCorePatch {
  return {
    deactivated: userFormValues.deactivated,
    email: userFormValues.email,
    firstname: userFormValues.firstname,
    lastname: userFormValues.lastname,
    // form gives us undefined for empty,
    // but to be included into the JSON to be sent to backend we need a defined value,
    // and as the backend is really stupid when differentiating between null und 'not set', we set an empty string
    username: userFormValues.username || '',
  };
}
